export default __webpack_public_path__ + "static/media/english-to-polish-mobile-1.f352300a.png";